module.exports = __webpack_public_path__ + "img/team.92d4ae86.svg";